import React from 'react';
import './Advantage.css';
import { Link } from 'react-router-dom';
// Import the icons we'll use for each card
import { FaUsers, FaRegCalendarAlt, FaShieldAlt, FaDatabase } from 'react-icons/fa';

// Array of data for our advantage cards
const advantageData = [
  {
    icon: <FaUsers />,
    title: 'Confident negotiations',
    description: 'Make informed deals backed by transparent prices and data-driven market intelligence.'
  },
  {
    icon: <FaRegCalendarAlt />,
    title: 'Connect, learn & grow',
    description: 'Join industry leaders at CRISHI\'s conferences, plant tours, and webinars to spark ideas and unlock opportunities.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Audits & compliance',
    description: 'Ensure regulatory adherence with accurate data and streamlined audit processes.'
  },
  {
    icon: <FaDatabase />,
    title: 'Trade data analysis & data archive',
    description: 'Study past data & price trends to anticipate market shifts, mitigate risks, and forecast future.'
  }
];

const Advantage = () => {
  return (
    <section className="advantage-section">
      <div className="section-header">
        <h2>How We Create Advantage</h2>
        <div className="header-line"></div>
      </div>

      <div className="advantage-grid">
        {advantageData.map((item, index) => (
           <Link to="/advantages" key={index} className="advantage-card-link">
          <div key={index} className="advantage-card">
            <div className="advantage-icon">
              {item.icon}
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Advantage;